import { SparkMark } from "./SparkLogo";

const ITEMS = [
  "100% organic cotton",
  "Free express shipping over £50",
  "30-day happy returns",
  "Dermatologist-approved fabrics",
  "Where kids shine",
];

export default function Marquee() {
  return (
    <section className="relative my-4 overflow-hidden" data-testid="brand-marquee">
      <div className="overflow-hidden bg-gradient-to-r from-blush-500 via-lav-500 to-baby-500 py-3.5 shadow-sm">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((copy) => (
            <div
              key={copy}
              aria-hidden={copy === 1}
              className="flex items-center gap-10 pr-10"
            >
              {ITEMS.map((item) => (
                <span
                  key={item}
                  className="flex items-center gap-10 whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.25em] text-white"
                >
                  {item}
                  <SparkMark size={16} className="shrink-0" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
